import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import * as React from "react";
import reactStringReplace from "react-string-replace";
import { SearchResultItemWrap, SearchResultLink, SearchItemDescription, SearchHighlightedText } from "./searchbox.elements";
import { StyledOperationBadge } from "../UserComponents/styled.elements";
import { normalizeRedocBadge } from "../../utils";

var SearchResultItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SearchResultItem, _React$Component);

  function SearchResultItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SearchResultItem.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.scrollIntoViewIfActive();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.scrollIntoViewIfActive();
  };

  _proto.scrollIntoViewIfActive = function scrollIntoViewIfActive() {
    this.props.active && this.ref && this.ref.scrollIntoView({
      block: "end",
      behavior: "smooth"
    });
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        a = _this$props.query,
        b = _this$props.item,
        c = b.link,
        d = b.label,
        e = b.httpVerb,
        f = this.getSearchItemDescription(b),
        g = "string" == typeof f ? this.getSearchResultText(f, a) : f;
    return /*#__PURE__*/React.createElement(SearchResultLink, {
      to: c
    }, /*#__PURE__*/React.createElement(SearchResultItemWrap, {
      active: this.props.active,
      ref: function ref(a) {
        return _this.ref = a;
      },
      "data-cy": d
    }, e && /*#__PURE__*/React.createElement(StyledOperationBadge, {
      type: e
    }, normalizeRedocBadge(e)), this.getSearchResultText(d, a), g && /*#__PURE__*/React.createElement(SearchItemDescription, null, g)));
  };

  _proto.getSearchResultText = function getSearchResultText(a, b, c) {
    if (c === void 0) {
      c = 60;
    }

    var d = a.toLowerCase(),
        e = b.toLowerCase(),
        f = d.indexOf(e),
        g = e.length,
        h = c - g;
    return reactStringReplace(this.getSurroundText(f - h / 2, f + h / 2, a, g), b, function (a, b) {
      return /*#__PURE__*/React.createElement(SearchHighlightedText, {
        key: b
      }, a);
    });
  };

  _proto.getSurroundText = function getSurroundText(a, b, c, d) {
    if (0 < a && b < c.length) return "..." + c.slice(a, b) + "...";

    if (0 > a && b < c.length) {
      var e = b - a + d;
      return e < c.length ? c.slice(0, e) + "..." : c.slice(0, e);
    }

    if (0 < a && b > c.length) {
      var _d = a - (b - c.length);

      return 0 > _d ? c.slice(0, c.length) : "..." + c.slice(_d, c.length);
    }

    return c;
  };

  _proto.getSearchItemDescription = function getSearchItemDescription(a) {
    var b = this.props.query;
    if (a.meta && 1 === a.meta.length) return a.meta[0].place ? a.meta[0].place + " " + formatPath(b, a.meta[0].path) : "";

    if (a.meta && 1 < a.meta.length) {
      var _b = {};

      for (var _iterator = _createForOfIteratorHelperLoose(a.meta), _step; !(_step = _iterator()).done;) {
        var _c = _step.value;
        _c.place && (_b[_c.place] = !0);
      }

      var c = Object.keys(_b);
      return c.length ? /*#__PURE__*/React.createElement(React.Fragment, null, a.meta.length, " matching ", /*#__PURE__*/React.createElement("strong", null, formatPlaces(c))) : "";
    }

    return a.content;
  };

  return SearchResultItem;
}(React.Component);

export { SearchResultItem as default };

function formatPlaces(a) {
  return 1 === a.length ? a[0] : (a.sort(), a.slice(0, a.length - 1).join(", ") + " and " + a[a.length - 1]);
}

function formatPath(a, b) {
  return b && 0 !== b.length ? " \u2192 " + b.join(" \u2192 ") : "";
}